import { Handicapping, Timeform } from "@tvg/ts-types/Race";
import { PICKS_DATA_SOURCE, pickIcon } from "../InlineAnalyses/constants";

export const getTimeformFreePickNbr = (timeform?: Timeform) =>
  timeform?.freePick?.number;

export const isTimeformFreePickTagShown = (
  timeform?: Timeform,
  trackDataSource?: string
) =>
  timeform &&
  !!getTimeformFreePickNbr(timeform) &&
  trackDataSource === PICKS_DATA_SOURCE.USGSA;

export const getHandicappingFreePickNbr = (handicapping?: Handicapping) =>
  handicapping?.freePick?.number;

export const isHandicappingFreePickTagShown = (handicapping?: Handicapping) =>
  handicapping && !!getHandicappingFreePickNbr(handicapping);

export const getHandicappingIconName = (trackDataSource?: string) =>
  (trackDataSource && pickIcon[trackDataSource as string]) || pickIcon.default;
